<template>
<div class="izk-login">
	
	<Back title="重置密码"></Back> 

    <p class="izk-password-txt">请验证手机</p>

    <!-- 短信登录 -->
    <div class="g-check izk-login-form">
        <SmsCode title="下一步" @sonClick="sonClick" ></SmsCode>
		<!-- <div id="captcha"></div> -->
        <div class="forget">
            <a href="javascript:void(0)" @click='goLogin'>想起密码,去登录</a>
        </div>
    </div>

    <div class="dialog-bg vcbox" v-if="phoneNoRegist">
        <div class="dialog pop-fail">
            <div class="dialog-con">
                <i class="ico-fail"></i>
                <p class="title">手机号码未注册</p>
                <p class="info">
                    可以短信登录哦,更加方便快捷
                </p>
            </div>
            <div class="dialog-foot hbox">
                <a href="javascript:;" class="flex link cor1" @click="cancel">取消</a>
                <a href="javascript:;" class="flex link" @click="toSmsLogin">短信登录</a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
	import '@/components/common/css/login/login.css';
	import Back from '@/components/public/back/Back.vue';
	import SmsCode from '@/components/public/smsCode/SmsCode.vue';
	import api from '../../../common/libs/api.js';
	import utils from '../../../common/libs/utils.js';
	import {getSign} from '../../../common/libs/common.js';
	import localforage from 'localforage';

	export default{
	  name: 'Phone',
	  components: {
	    Back,
	    SmsCode
	  },
	  data(){
	    return {
	      phoneNoRegist: false
	    }
	  },
	  methods: {
	    cancel(){
	      this.phoneNoRegist = false;
	    },
	    toSmsLogin(){
	      this.phoneNoRegist = false;

	      this.$router.push({name: 'login', query: this.$route.query});
	    },
	    goLogin(){				
			this.$router.push({name: 'login', query: {passwordLogin: 1}});
		},
		sonClick(phone, code){
			// let vm = this;
			// let data = {
			// 	phone: phone,
			// 	phone_code: 86,
			// 	sms_code: code
			// };
			// var params={
			// 	data,
			// 	success: function(res){
			// 	if (res.errcode == 11021) {
			// 		// 需要展示滑块
			// 		// 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
			// 		vm.smsLoginNow = false;
			// 		var slideParam = {
			// 			slideCallback: 'loginSms', // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSmsCodeLogin），校验旧手机（checkPhone））
			// 			slideParams: params, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
			// 			failCallback: function (error) {
			// 				vm.$store.dispatch('toast', {title: error.errmsg, show: true});
			// 			} // 方法名出错
			// 		}
			// 		// 展示滑块
			// 		TAL_UC.showSlide(slideParam)
			// 		// that.loginLoading = false;
			// 		return
			// 	} else if (res.errcode == 0){
			// 		vm.exchangeToken(res);
			// 		vm.smsLoginNow = false;
			// 	} else {
			// 		vm.smsLoginNow = false;
			// 		vm.$store.dispatch('toast', {title: res.errmsg, show: true});
			// 	}
			// 	},
			// 	fail: function(res){
			// 	vm.smsLoginNow = false;
			// 	vm.$store.dispatch('toast', {title: res.errmsg, show: true});
			// 	}
			// }
			// TAL_UC.loginSms(params);
			let vm = this;
			let obj = {
				phone: phone,
				sms_code: code,
				type: 'sms',
				function_type: 2,
				code_type: 4
			};
			//obj.sign = getSign(obj);
			api.apiMethod.cehckUser.post(obj).then(res => {
				
				if (res.data.code == 0){
					localStorage.setItem('token', res.data.data.token);
					utils.cookie.set('token', res.data.data.token, '.izhikang.com', '/', 24*7);
					localforage.setItem('token', res.data.data.token);
					localforage.setItem('izk-user', res.data.data);

					vm.$store.commit('addMine', {state: res.data.data});
					vm.$router.push({name: 'reset', query: this.$route.query});
				} else if (res.data.code == '20005'){
					vm.phoneNoRegist = true;
				} else {
					vm.$store.dispatch('toast', {title: res.data.msg, show: true});
				}
			})
		}
		},
		created(){
			this.$store.commit('isShowHeader', {isShowHeader: false});
			this.$store.commit('isShowFooter', {isShowFooter: false});
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/mine/reset/Phone.vue